import {
  GET_EMPLOYEEWARNING,
  GET_EMPLOYEEWARNING_SUCCESS,
  GET_EMPLOYEEWARNING_FAIL,
  DELETE_EMPLOYEEWARNING,
  DELETE_EMPLOYEEWARNING_SUCCESS,
  DELETE_EMPLOYEEWARNING_FAIL,
  UPDATE_EMPLOYEEWARNING,
  UPDATE_EMPLOYEEWARNING_SUCCESS,
  UPDATE_EMPLOYEEWARNING_FAIL,
  ADD_NEW_EMPLOYEEWARNING,
  ADD_EMPLOYEEWARNING_SUCCESS,
  ADD_EMPLOYEEWARNING_FAIL,
  EMPLOYEEWARNING_LOADING,
  EMPLOYEEWARNING_RESET
} from "./actionType";

export const resetEmployeeWarningState = (actionType) => ({
  type: EMPLOYEEWARNING_RESET,
  payload: { actionType },
});

export const getEmployeeWarningSuccess = (actionType, data) => ({
  type: GET_EMPLOYEEWARNING_SUCCESS,
  payload: { actionType, data },
});

export const getEmployeeWarningFail = (actionType, error) => ({
  type: GET_EMPLOYEEWARNING_FAIL,
  payload: { actionType, error },
});

export const getEmployeeWarning = data => ({
  type: GET_EMPLOYEEWARNING,
  payload: data,
});

export const getEmployeeWarningLoading = () => ({
  type: EMPLOYEEWARNING_LOADING
});

export const deleteEmployeeWarning = data => ({
  type: DELETE_EMPLOYEEWARNING,
  payload: data,
});

export const deleteEmployeeWarningSuccess = data => ({
  type: DELETE_EMPLOYEEWARNING_SUCCESS,
  payload: data,
});

export const deleteEmployeeWarningFail = error => ({
  type: DELETE_EMPLOYEEWARNING_FAIL,
  payload: error,
});

export const updateEmployeeWarning = data => ({
  type: UPDATE_EMPLOYEEWARNING,
  payload: data,
});

export const updateEmployeeWarningFail = error => ({
  type: UPDATE_EMPLOYEEWARNING_FAIL,
  payload: error,
});

export const updateEmployeeWarningSuccess = data => ({
  type: UPDATE_EMPLOYEEWARNING_SUCCESS,
  payload: data,
});

export const addNewEmployeeWarning = data => ({
  type: ADD_NEW_EMPLOYEEWARNING,
  payload: data,
});

export const addEmployeeWarningSuccess = data => ({
  type: ADD_EMPLOYEEWARNING_SUCCESS,
  payload: data,
});

export const addEmployeeWarningFail = error => ({
  type: ADD_EMPLOYEEWARNING_FAIL,
  payload: error,
});